/**
 * خالتي هيلة - Main App with Router
 * Mobile First Design
 */

import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

// Pages
import Home from './pages/Home';
import Features from './pages/Features';
import HowItWorks from './pages/HowItWorks';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthApp from './components/AuthApp';

// Simple Router
const useRouter = () => {
  const [path, setPath] = useState(window.location.hash.slice(1) || '/');
  
  useEffect(() => {
    const handleHashChange = () => {
      setPath(window.location.hash.slice(1) || '/');
    };
    
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  
  const navigate = (newPath) => {
    window.location.hash = newPath;
  };
  
  return { path, navigate };
};

export default function App() {
  const { path, navigate } = useRouter();
  const [showApp, setShowApp] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user wants to access app directly
    if (path === '/app' || path === '/login' || path === '/signup') {
      setShowApp(true);
    } else {
      setShowApp(false);
    }
    setLoading(false);
  }, [path]);

  // Loading Screen
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-rose-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">👩‍🦳💕</div>
          <Heart className="w-8 h-8 text-rose-500 animate-pulse mx-auto" />
        </div>
      </div>
    );
  }

  // Show Auth App
  if (showApp) {
    return <AuthApp onBack={() => navigate('/')} />;
  }

  // Website Pages
  const renderPage = () => {
    switch (path) {
      case '/features':
        return <Features />;
      case '/how-it-works':
        return <HowItWorks />;
      case '/faq':
        return <FAQ />;
      case '/contact':
        return <Contact />;
      case '/terms':
        return <Terms />;
      case '/privacy':
        return <Privacy />;
      default:
        return <Home onStartClick={() => navigate('/app')} />;
    }
  };

  return (
    <div className="font-sans" dir="rtl">
      <Navbar 
        currentPath={path} 
        navigate={navigate} 
        onLoginClick={() => navigate('/app')}
      />
      <main>
        {renderPage()}
      </main>
      <Footer navigate={navigate} />
    </div>
  );
}
